// usePageDto.js
import { reactive, nextTick } from 'vue'
import getPageDto from '../../../common-frontend/src/functions/getPageDto'

export function usePageDto(initialFetchList = null, tableRef = null) {
    // 创建响应式的 pageDto
    const pageDto = reactive(getPageDto())
    let fetchList = initialFetchList

    /**
     * 调用 fetchList 并在完成后重新布局表格
     * 用于解决表格滑动后错位的问题
     */
    const callFetchListAndLayout = async () => {
        if (typeof fetchList === 'function') {
            const result = fetchList()
            // 如果是 Promise，等待完成
            if (result && typeof result.then === 'function') {
                await result
            }
            // 数据更新后重新布局表格
            if (tableRef && tableRef.value) {
                await nextTick()
                tableRef.value.doLayout()
            }
        }
    }

    /**
     * 刷新列表 - 重置为第一页并获取数据
     * @param {Function} fetchList - 获取列表数据的函数
     */
    const refresh = () => {
        pageDto.pageNum = 1
        callFetchListAndLayout()
    }
    /**
     * 翻页 - 改变页码并获取数据
     */
    const changePage = (pageNum) => {
        pageDto.pageNum = pageNum
        callFetchListAndLayout()
    }

    /**
     * 改变每页显示条数 - 重置为第一页并获取数据
     * @param {Number} pageSize - 每页条数
     * @param {Function} fetchList - 获取列表数据的函数
     */
    const changeSize = (pageSize) => {
        pageDto.pageSize = pageSize
        pageDto.pageNum = 1
        callFetchListAndLayout()
    }

    return {
        pageDto,
        refresh,
        changePage,
        changeSize,
    }
}
